<template>
    <div class="vx-row ml-1 mt-3">
        <!-- <div class="vx-row mb-6" style="width:70%">
            <div class="vx-col sm:w-1/4 w-full flex items-center">
                <span>Supplier</span>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
                <Supplier 
                    :multiple="multiSp"
                    placeholder="ALL Supplier"
                    @selected="(val) => {
                        this.selectedSupplier = val
                    }"
                ></Supplier>
            </div>
        </div> -->
        <div class="vx-row mb-6" style="width:70%">
            <div class="vx-col sm:w-1/4 w-full flex items-center">
                <span>Warehouse</span>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
                <Warehouse 
                    :multiple="multiWh"
                    placeholder="ALL Warehouse"
                    @selected="(val) => {
                        this.selectedWarehouse = val
                    }"
                ></Warehouse>
            </div>
        </div>
        <div class="vx-row mb-1" style="width:70%">
            <div class="vx-col sm:w-1/4 w-full flex items-center">
            </div>
            <div class="vx-col sm:w-3/4 w-full">
                <vs-button color="primary" @click="handleFilter()">Filter</vs-button>
            </div>
        </div>
    </div>
</template>
<script>
import Warehouse from "@/components/Warehouse.vue";
import Supplier from "@/components/Supplier.vue";
export default {
    components: {
        Warehouse,
        Supplier,
    },
    props: {
        multiSp: {
            type: Boolean,
            default: false,
        },
        multiWh: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            draw: 0,
            selectedWarehouse: (this.multiWh) ? [] : null,
            selectedSupplier: (this.multiSp) ? [] : null,
        }
    },
    methods: {
        handleFilter() {
            this.draw++;
            this.emitData()
        },
        emitData() {
            const supplierIds = this.selectedSupplier.map(supplier => {
                return supplier.id;
            });

            const warehouseIds = this.selectedWarehouse.map(warehouse => {
                return warehouse.id;
            });

            this.$emit("data", {
                draw: this.draw,
                warehouseId: warehouseIds,
                supplierId: supplierIds,
            });
        },
    },
    watch: {
    },
}
</script>